import { useState } from "react";
import { Mail, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.subscribe(email, "newsletter");
      toast.success(r.already ? "Already on the list" : "Subscribed!", {
        description: "Weekly top-rated templates, curated automatically.",
      });
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="pricing" className="border-b border-white/10 bg-slate-900 py-20 lg:py-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-10 border border-white/10 bg-slate-950 p-10 lg:grid-cols-2 lg:p-16">
          <div>
            <div className="mb-4 flex h-11 w-11 items-center justify-center bg-emerald-500 text-slate-900">
              <Mail className="h-5 w-5" />
            </div>
            <h2 className="font-display text-3xl font-extrabold tracking-tighter text-white sm:text-4xl">
              The weekly digest,
              <br />
              <span className="text-emerald-400">on autopilot.</span>
            </h2>
            <p className="mt-4 max-w-md text-base leading-relaxed text-slate-400">
              Get the highest-rated templates of the week delivered to your inbox — curated and
              written by our engine, never by hand.
            </p>
          </div>
          <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row">
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="flex-1 border border-white/15 bg-slate-900 px-4 py-3.5 text-white outline-none transition-colors duration-200 placeholder:text-slate-500 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500"
            />
            <button
              data-testid="newsletter-submit"
              disabled={loading}
              className="group inline-flex items-center justify-center gap-2 bg-emerald-500 px-6 py-3.5 font-semibold text-slate-900 transition-[background-color] duration-200 hover:bg-emerald-400 disabled:opacity-60"
            >
              {loading ? "Joining..." : "Subscribe"}
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
